module.exports = __webpack_public_path__ + "static/bwc-logo-553c3e894f56b991634759e159d18567.jpg";